import { useAction, useAtom } from '@reatom/npm-react'

import { SoundOffIcon, SoundOnIcon } from '@blade/ui-kit'

import {
  soundNotificationsEnabledAtom,
  toggleSoundNotificationsActions,
} from '../../../atoms/reatom-alerts-notifications'

import { ToggleButton } from './wallet-alerts-dialog-common'

type Props = {}

export const WalletAlertsSoundNotificationToggle: React.FC<Props> = () => {
  const [soundNotificationsEnabled] = useAtom(soundNotificationsEnabledAtom)
  const toggleSoundNotifications = useAction(toggleSoundNotificationsActions)

  return (
    <ToggleButton
      data-active={soundNotificationsEnabled}
      size="xs"
      variant="soft"
      radius="rounded"
      iconRight={soundNotificationsEnabled ? <SoundOnIcon /> : <SoundOffIcon />}
      onClick={toggleSoundNotifications}
    />
  )
}
